
import { computed, defineComponent, PropType, reactive } from 'vue'
import { getClientEvents, getClientVisits } from '../api'
import { formatDateTime, formatFullDate, initials, plural, visitsLabel } from '../helpers'
import { ClientEvent, ClientVisit, HotWindowCandidate } from '../types'
import HwIcon from './HwIcon.vue'

/**
 * Карточка клиента. Лента и визиты — те же ручки, что в карточке клиента
 * списка задач, чтобы данные двух виджетов не расходились. Компонент
 * монтируется на каждое открытие, поэтому грузим сразу в setup.
 */
export default defineComponent({
    name: 'HotWindowsClientDrawer',
    components: { HwIcon },
    props: {
        candidate: { type: Object as PropType<HotWindowCandidate>, required: true },
        projectId: { type: String, required: true },
    },
    emits: ['close'],
    setup(props) {
        const opened = reactive({ events: false, visits: false })
        const events = reactive({ loading: true, error: false, items: [] as ClientEvent[] })
        const visits = reactive({ loading: true, error: false, items: [] as ClientVisit[] })
        const query = { projectId: props.projectId, clientId: props.candidate.clientId }

        getClientEvents(query).then(({ data, error }) => {
            events.loading = false
            events.error = Boolean(error) || !Array.isArray(data)
            events.items = Array.isArray(data) ? data : []
        })
        getClientVisits(query).then(({ data, error }) => {
            visits.loading = false
            visits.error = Boolean(error) || !Array.isArray(data)
            visits.items = Array.isArray(data) ? data : []
        })

        return {
            opened,
            events,
            visits,
            avatar: computed(() => initials(props.candidate.name)),
            visitsCount: computed(() => visitsLabel(props.candidate.totalVisits)),
            lastVisit: computed(() => formatFullDate(props.candidate.lastVisited)),
            eventsCount: computed(() => {
                if (events.loading) return 'Что уже отправляли клиенту'
                const count = events.items.length
                return `Что уже отправляли клиенту · ${count} ${plural(count, 'событие', 'события', 'событий')}`
            }),
            eventTitle: (event: ClientEvent) =>
                event.activationName ||
                (event.textMessage ? 'Отправлено сообщение' : event.comment ? 'Комментарий' : 'Коммуникация'),
            eventText: (event: ClientEvent) => event.textMessage || event.comment || '',
            eventStatus: (event: ClientEvent) =>
                [event.communicationType, event.userName].filter(Boolean).join(' · '),
            formatDateTime,
            formatFullDate,
        }
    },
})
